import template from './message.html'
import { fapp } from '../../fapp'

const pageMessage = () => {
  return {
    title: 'ОБРАТНАЯ СВЯЗЬ',
    showAttach: true,
    messages: [],
    text: '',
    previewImg: null,
    async init() {
      this.$nextTick(_ => {
        this.$el.innerHTML = template
      })
      this.loadMessages()
    },
    async loadMessages() {
      this.messages = await fapp.service('/api/feedback').find({ query: { $paginate: 'false', $sort: { createdAt: 1 }} } )
      this.$nextTick(_ => {
        this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight
      })
    },
    async sendMessage() {
      let imgId = null
      if (this.previewImg != null) {
        const file = await fapp.service('/api/uploads').create({ type: 'feedback', uri: this.previewImg } )
        imgId = file.id
      }
      await fapp.service('/api/feedback').create({ message: this.text, screenshotUrl: imgId } )
      this.text = ''
      this.showAttach = true
      this.previewImg = null
      this.loadMessages()
    },
    async addAttach(files) {
      if (files.length == 0) {
        this.showAttach = true
        this.previewImg = null
        return
      }
      const reader = new FileReader()

      reader.addEventListener('load',
        () => {
          this.showAttach = false
          this.previewImg = reader.result
        },
        false,
      );
    
      reader.readAsDataURL(files[0])
    }
  }
}

export { pageMessage }
